










































































































































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import CurrenciesStore from "@/mixins/constants/currenciesStore";

// Enums/Data
import { DiscountTypes, PromotionTypes } from "@/data/enums/promotions";
import { DataModules } from "@/store/modules/data";

// Types
import { IPromotion } from "@/models/promotions";

@Component({
  components: {
    "promotion-item-status": () =>
      import(
        "@/components/app/admin/catalogue/promotions/promotionItemStatus.vue"
      )
  }
})
export default class PromotionListItem extends Mixins(CurrenciesStore) {
  // Props

  @Prop({ required: true })
  public promotion!: IPromotion;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data

  public promotionType: PromotionTypes = PromotionTypes.GLOBAL;

  // Computed

  public async created() {
    this.promotionType = this.$store.getters[
      `data/${DataModules.CATALOGUE_PROMOTIONS}/getPromotionType`
    ](this.promotion);
  }

  public get promotionTypeText() {
    if (this.promotionType === PromotionTypes.INDIVIDUAL) {
      return this.$t("_.custom_promotion_discount_type", {
        conditions: this.$tc(
          "_plurals.conditions",
          this.promotion.products.length
        )
      });
    }
    const promo = this.promotion.products?.[0] || this.promotion;
    const amount = promo.amount;
    const isPercentageBased =
      (promo.type || promo.type) === DiscountTypes.PERCENTAGE_BASED;

    const currency = this.$_.find(this.currencies, [
      "id",
      this.$_.get(
        this.promotion,
        "products[0].currency_id",
        this.promotion.currency_id
      )
    ]);

    return this.$t("_.promotion_discount_type", {
      discount: isPercentageBased
        ? `${amount}% ${this.$t("_.off")
            .toString()
            .toLowerCase()}`
        : `${currency?.prefix}${amount}${currency?.suffix} ${currency?.code}`,
      products:
        this.promotionType === PromotionTypes.GLOBAL
          ? this.$t("_.all_products")
          : this.$tc(
              "_plurals.selected_products",
              this.promotion.products.length
            )
    });
  }

  public get promotionName() {
    return `${this.promotion.name} (${this.$t("_.code")}: ${
      this.promotion.code
    })`;
  }

  // Computed

  public get isHidden() {
    return this.promotion?.hidden;
  }

  public get itemRoute() {
    return {
      name: "admin__promotion",
      params: { promotionId: this.promotion.id }
    };
  }
}
